import React from "react";

class PageNotFound extends React.Component {
    render() {
        return (
            <div>
                <h2>Error 404: Page not found</h2>
            </div>
        );
    }
}

export default PageNotFound;
